import { Divider as DividerAntd } from 'antd';
import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

type SectionTitleProps = {
  $color?: COLOR;
  $noMargin?: boolean;
};

type DividerProps = {
  $color?: COLOR;
  $dividerMargin?: string;
};

export const Container = styled.div`
  display: flex;
  align-items: baseline;
`;

export const SectionTitle = styled.h2<SectionTitleProps>`
  width: 100%;
  text-transform: uppercase;
  font-weight: bold;
  line-height: 18px;
  font-size: 14px;
  color: ${({ $color }) => $color || `${COLOR.CHEMISTRY}`};
  margin-top: ${({ $noMargin }) => ($noMargin ? '0px' : '50px')};
`;

export const Divider = styled(DividerAntd)<DividerProps>`
  margin-top: 10px;
  margin-bottom: ${({ $dividerMargin }) => $dividerMargin || '40px'};
  ${({ $color }) => $color && `background-color: ${$color};`}
`;
